import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { images, recentBuyers } from "../data/offer";
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const cycle = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutesAgo(1 + Math.floor(Math.random() * 9));
      setShow(true);
      hideTimer = window.setTimeout(() => setShow(false), 5000);
    };
    const first = window.setTimeout(cycle, 6000);
    const loop = window.setInterval(cycle, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:left-5 sm:right-auto sm:w-[360px]" aria-live="polite" data-id="element-66" data-mp="164ej8hc45uny">
      <AnimatePresence data-id="element-67" data-mp="1151v7t9iahjs">
        {show && !dismissed && <motion.div initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border border-line bg-white p-3 pr-9 shadow-[0_14px_40px_-10px_rgba(7,27,51,0.45)]" data-id="element-68" data-mp="1fuhd0jr27cnc">
            <img src={images.collection} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-mist object-cover" data-id="element-69" data-mp="s67t5ndeoyyu" />
            <div className="min-w-0" data-id="element-70" data-mp="28k7rwv0imiki">
              <p className="text-sm leading-snug text-ink" data-id="element-71" data-mp="28j4z2hjmu61y">
                <strong data-id="element-72" data-mp="23lmz3gnlf163">{buyer.name}</strong> from <strong data-id="element-73" data-mp="23klcqg14ms92">{buyer.country}</strong> just purchased
              </p>
              <p className="truncate text-sm font-bold text-brand" data-id="element-74" data-mp="2apcrmzy5v1hx">Renal Nutrition Clinical Blueprint™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs text-muted" data-id="element-75" data-mp="2fmuzso4ctcov">
                <BadgeCheckIcon className="h-3.5 w-3.5 text-mint" aria-hidden="true" data-id="element-76" data-mp="2km7oleesctu3" />
                Verified purchase · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 hover:bg-mist hover:text-ink" data-id="element-77" data-mp="1ry3gkm8qs4o8">
              <XIcon className="h-4 w-4" data-id="element-78" data-mp="21ueu1fk2j0k9" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}